export function toBool(value, defaultValue) {
    if (defaultValue === void 0) { defaultValue = false; }
    if (value === true || value === 'true') {
        return true;
    }
    else if (value === false || value === 'false') {
        return false;
    }
    else {
        return defaultValue;
    }
}
